<template>
  <span
    class="inline-flex items-center justify-center gap-1.5 rounded-full border text-xs font-medium px-2.5 py-0.5"
    :class="statusMeta.color"
    v-bind="$attrs"
  >
    <i :class="statusMeta.icon" class="text-[10px]"></i>
    {{ statusMeta.label }}
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { ShopifyBalanceTransactionProcessingState } from '@/types/shopifyPayouts'

interface StatusMeta {
  label: string
  icon: string
  color: string
}

const STATUS_CONFIG: Record<
  ShopifyBalanceTransactionProcessingState,
  StatusMeta
> = {
  PENDING: {
    label: 'Pending',
    icon: 'pi pi-clock',
    color:
      'bg-yellow-50 text-yellow-700 border-yellow-200 dark:bg-yellow-900/20 dark:text-yellow-200 dark:border-yellow-700',
  },
  PENDING_CONFIRMATION: {
    label: 'Pending Confirmation',
    icon: 'pi pi-exclamation-circle',
    color:
      'bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-900/20 dark:text-amber-200 dark:border-amber-700',
  },
  PROCESSING: {
    label: 'Processing',
    icon: 'pi pi-spin pi-spinner',
    color:
      'bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-900/20 dark:text-blue-200 dark:border-blue-700',
  },
  PROCESSED: {
    label: 'Processed',
    icon: 'pi pi-check-circle',
    color:
      'bg-green-50 text-green-700 border-green-200 dark:bg-green-900/20 dark:text-green-200 dark:border-green-700',
  },
  SKIPPED: {
    label: 'Skipped',
    icon: 'pi pi-minus-circle',
    color:
      'bg-surface-50 text-surface-700 border-surface-200 dark:bg-surface-800 dark:text-surface-200 dark:border-surface-700',
  },
  FAILED: {
    label: 'Failed',
    icon: 'pi pi-times-circle',
    color:
      'bg-red-50 text-red-700 border-red-200 dark:bg-red-900/20 dark:text-red-200 dark:border-red-700',
  },
  PARTIALLY_FAILED: {
    label: 'Partially Failed',
    icon: 'pi pi-exclamation-triangle',
    color:
      'bg-orange-50 text-orange-700 border-orange-200 dark:bg-orange-900/20 dark:text-orange-200 dark:border-orange-700',
  },
}

const props = defineProps<{
  status: ShopifyBalanceTransactionProcessingState
}>()

const statusMeta = computed(
  () => STATUS_CONFIG[props.status] || STATUS_CONFIG.PENDING,
)
</script>
